module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.isShow) ? _c('div', {
    staticClass: "menu",
    attrs: {
      "transition": "menu"
    }
  }, [_c('ul', [_c('li', {
    class: {
      'active': _vm.$route.name == 'home'
    },
    on: {
      "click": _vm.clickMenu
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        'name': 'home'
      }
    }
  }, [_vm._v("首页")])], 1), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.$route.name == 'about'
    },
    on: {
      "click": _vm.clickMenu
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        'name': 'about'
      }
    }
  }, [_vm._v("关于")])], 1), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.$route.name == 'news'
    },
    on: {
      "click": _vm.clickMenu
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        'name': 'news'
      }
    }
  }, [_vm._v("新闻")])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.isShow) ? _c('div', {
    staticClass: "menu-mask",
    attrs: {
      "transition": "mask"
    },
    on: {
      "click": _vm.clickMenu
    }
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.3.0@vue-loader/lib/template-compiler.js?id=data-v-b48f656e!./~/.10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/menu.vue
// module id = 38
// module chunks = 1